import React, { useEffect, useMemo, useState } from 'react';
import {
  createNewKeyValueForOrgaAndPhase,
  KeyValEntry,
  updateKeyValueForOrgaAndPhase
} from '../../../Helper/ApiHelper/KeyValueNetworkHelper';
import { TimelineStep } from '../../Atoms/BeeTimeline';
import BeeDateInput from '../../Atoms/BeeDateInput';
import BeeContentHeadline from '../../Atoms/BeeContentHeadline';
import {
  generatePriceValidUntilKey,
  isKeyPriceValidUntilKey
} from '../../../Helper/Util/IdGeneratorHelper';
import {
  SERVER_RESPONSE_ERROR,
  SERVER_RESPONSE_PENDING,
  SERVER_RESPONSE_SUCCESS
} from '../../../Helper/Statics/Constants';
import { extractUserId } from '../../../Helper/Util/JwtHelper';
import BeeValidatedDateInput from '../../Atoms/BeeValidatedDateInput';

type DlEffectivenessInputProps = {
  readOnly: boolean;
  phase: TimelineStep;
  keyValues: KeyValEntry[];
  onReloadKeyValues: () => void;
};
export default function DlEffectivenessInput({
  readOnly,
  phase,
  keyValues,
  onReloadKeyValues
}: DlEffectivenessInputProps) {
  const [keyValueEntry, setKeyValueEntry] = useState<KeyValEntry | null>(null);
  const [validDate, setValidDate] = useState<Date | null>(null);
  const [validDateProcess, setValidDateProcess] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const keyValueEntry = keyValues.find((keyValue) =>
      isKeyPriceValidUntilKey(keyValue.key)
    );
    if (keyValueEntry) {
      setValidDate(new Date(keyValueEntry.value));
      setKeyValueEntry(keyValueEntry);
    }
    setIsLoading(false);
  }, [keyValues]);

  function changeValidDate(val: string | Date | null | undefined) {
    let currValue = val ? new Date(val) : null;
    if (validDate !== currValue || validDateProcess === SERVER_RESPONSE_ERROR) {
      const dbId = keyValueEntry?.id;
      let userId: string = 'no_user';
      const extracted = extractUserId();
      userId = extracted ? extracted : userId; //=orgaid
      const priceValidUntilKey = generatePriceValidUntilKey(phase.id);
      setValidDate(currValue);
      setValidDateProcess(SERVER_RESPONSE_PENDING);

      if (dbId) {
        updateKeyValueForOrgaAndPhase(
          userId,
          phase.id,
          dbId,
          priceValidUntilKey,
          currValue ? currValue.toISOString() : null
        )
          .then((responseValue) => {
            setValidDateProcess(SERVER_RESPONSE_SUCCESS);
            setValidDate(currValue);
            setKeyValueEntry(responseValue);
            onReloadKeyValues();
          })
          .catch(() => setValidDateProcess(SERVER_RESPONSE_ERROR));
      } else {
        createNewKeyValueForOrgaAndPhase(
          userId,
          phase.id,
          priceValidUntilKey,
          currValue ? currValue.toISOString() : null
        )
          .then((responseValue) => {
            setValidDateProcess(SERVER_RESPONSE_SUCCESS);
            setValidDate(currValue);
            setKeyValueEntry(responseValue);
            onReloadKeyValues();
          })
          .catch(() =>
            //dbId is initial value // null
            setValidDateProcess(SERVER_RESPONSE_ERROR)
          );
      }
    }
  }

  return (
    <div>
      <BeeContentHeadline
        label="Preisabgabe Wirksamkeit"
        headline="h2"
        type="primary"
      />
      <div className="pb-2">
        Hinweis: Die eingegebenen Rahmenpreise und Faktoren sind bis zum
        ausgewählten Stichtag gültig. Bitte geben Sie ein Datum an um mit der
        Preisabgabe zu beginnen.
      </div>
      <BeeValidatedDateInput
        label="Datum"
        value={validDate ? new Date(validDate) : undefined}
        disabled={readOnly}
        formstate={validDate || isLoading ? 'neutral' : 'error'}
        errorLabel="Bitte geben Sie ein Datum ein"
        onChange={(e) => {
          changeValidDate(e.target.value as Date);
        }}
      />
    </div>
  );
}
